(() => {
  function dispatchDate(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(now);
    const get = type => Number(parts.find(part => part.type === type).value);
    const date = new Date(Date.UTC(get('year'), get('month') - 1, get('day') + 2, 12));
    return new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(date);
  }
  if (!customElements.get('elvane-dispatch')) {
    customElements.define('elvane-dispatch', class extends HTMLElement {
      connectedCallback() { this.update(); this.timer = setInterval(() => this.update(), 60000); }
      disconnectedCallback() { clearInterval(this.timer); }
      update() { this.textContent = 'Dispatched on ' + dispatchDate(); }
    });
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-elvane-guide-open]');
    if (opener) document.getElementById(opener.dataset.elvaneGuideOpen)?.showModal();
    const unit = event.target.closest('[data-elvane-unit]');
    if (unit) {
      const dialog = unit.closest('dialog');
      dialog.dataset.unit = unit.dataset.elvaneUnit;
      dialog.querySelectorAll('[data-elvane-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === unit)));
    }
    const closer = event.target.closest('[data-elvane-guide-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.elvane-size-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
})();
